import React, { useState } from "react";
import "../../sass/files/homepage.scss";
import main from "../../assets/images/homepage/BG Image.png";
import buttonimage from "../../assets/images/button/Frame 218.svg";
import scroll from "../../assets/images/homepage/scrollimage.svg";
import Gallery from "./components/gallery/Gallery";
import { Helmet } from "react-helmet-async";

import Create from "./components/create/Create";
import Family from "./components/family/Family";
import Footer from "../../components/footer/Footer";
import { useNavigate } from "react-router-dom";
import useGetOrder from "../../hooks/queries/useGetOrder";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import api from "../../api/axios";
import logo from "../../assets/images/logo/logowhite.png";
import Faq from "./components/faq/faq";
import { MdClose } from "react-icons/md";
import animation from "../../assets/animation/lotie_v1.json";
import Lottie from "react-lottie";
import animation2 from "../../assets/animation/lf30_editor_bjixuktb.json";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";
import Review from "./components/review/Review";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Service from "./components/Service/Service";
import Navbar from "../../components/navbar/Navbar";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 10,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const images = [
  {
    image: main,
  },
  {
    image: main,
  },
  {
    image: main,
  },
];

const TrackingIndex = [
  {
    title: "Order Placed",
    step: "pending",
  },
  {
    title: "Price Quoted",
    step: "reviewed",
  },
  {
    title: "Design In Progress",
    step: "paid",
  },
  {
    title: "Completed",
    step: "completed",
  },
];

const Homepage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");
  const [oid, setOid] = React.useState("");
  const [order, setOrder] = useState(null);
  const [activeStep, setActiveStep] = useState(-1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openTalkToExperts = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleTrack = async () => {
    try {
      const response = await api.get(`/orders/track/${oid}`);
      setOrder(response.data);

      const index = TrackingIndex.findIndex(
        (item) => item.step === response.data.status
      );

      console.log("activeStep", index);
      setActiveStep(index);
    } catch (err) {
      console.log(err);
      alert("Invalid Order Id");
    }
  };

  return (
    <>
      <Helmet>
        <title>Custom 3D Model Service | 3D Spot</title>

        <meta
          name="description"
          content="3D Spot offers custom 3D model services worldwide. Get artist-made, print-ready STL files from photos, sketches, and references. Serving clients in the USA, Europe, and beyond."
        />

        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://3dspot.io/" />

        <meta property="og:title" content="Custom 3D Model Service | 3D Spot" />
        <meta
          property="og:description"
          content="Artist-made custom 3D models and print-ready STL files from photos. Trusted by clients worldwide."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://3dspot.io/" />
        <meta property="og:site_name" content="3D Spot" />
        <meta property="og:image" content="https://3dspot.io/og-image.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Custom 3D Model Service | 3D Spot" />
        <meta
          name="twitter:description"
          content="Convert images into print-ready 3D models and STL files. Manually sculpted by expert artists."
        />
        <meta name="twitter:image" content="https://3dspot.io/og-image.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "3D Spot",
            alternateName: "3DSpot",
            url: "https://3dspot.io/",
            logo: "https://3dspot.io/og-image.png",
            description:
              "3D Spot is a global 3D modeling studio that converts images into print-ready 3D models and STL files.",
            foundingDate: "2021",
            address: {
              "@type": "PostalAddress",
              addressCountry: "US",
            },
            areaServed: [
              "United States",
              "United Kingdom",
              "Germany",
              "France",
              "Canada",
              "India",
              "Europe",
              "Worldwide",
            ],
            sameAs: [
              "https://www.facebook.com/3dspotted",
              "https://www.instagram.com/_3dspot",
              "https://www.linkedin.com/company/3dspot",
              "https://www.trustpilot.com/review/3dspot.io",
              "https://share.google/FL1NLsKhsCq2Uwhjo",
            ],
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "3D Spot",
            alternateName: "3DSpot",
            url: "https://3dspot.io/",
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Custom 3D Model Service",
            serviceType: "Custom 3D Modeling and STL File Creation",
            provider: {
              "@type": "Organization",
              name: "3D Spot",
              url: "https://3dspot.io/",
            },
            description:
              "3D Spot provides custom 3D models and print-ready STL files from photos, sketches, and references.",
            areaServed: [
              "United States",
              "United Kingdom",
              "Germany",
              "France",
              "Canada",
              "India",
              "Europe",
              "Worldwide",
            ],
            url: "https://3dspot.io/",
          })}
        </script>
      </Helmet>

      <section id="policy">
        <div className="home-page w-screen max-w-screen">
          <div className="drawer drawer-end h-full w-screen">
            <input id="my-drawer-4" type="checkbox" className="drawer-toggle" />

            <div className="drawer-content w-screen">
              <label htmlFor="my-drawer-4"></label>

              {/* Custom Navbar */}
              {/* <header className="custom-navbar">
                <div className="custom-navbar-logo">
                  <Link to="/">
                    <img src={logo} alt="3D Spot" />
                  </Link>
                </div>

                <nav className="custom-navbar-links">
                  <label htmlFor="my-drawer-4">Track</label>
                  <Link to="/subscription">Subscription</Link>
                  <Link to="/gallery">Gallery</Link>
                  <Link to="/blog">Blog</Link>
                  <Link to="/about-us">About Us</Link>
                </nav>

                <div className="custom-navbar-actions">
                  <button
                    onClick={() => navigate("/login")}
                    className="navbar-login-btn"
                  >
                    Login
                  </button>

                  <button
                    onClick={() => navigate("/guest-quote")}
                    className="navbar-quote-btn"
                  >
                    Get Free Quote
                  </button>

                  <button
                    onClick={() => navigate("/dashboard/create")}
                    className="navbar-create-btn"
                  >
                    Create Order
                  </button>
                </div>

                <button
                  onClick={() => navigate("/guest-quote")}
                  className="mobile-header-quote-btn"
                >
                  Free Quote
                </button>

                <button
                  onClick={() => setMobileMenuOpen(true)}
                  className="hamburger-menu-btn"
                  aria-label="Open menu"
                >
                  ☰
                </button>
              </header>

              {mobileMenuOpen && (
                <div className="mobile-nav-overlay">
                  <div className="mobile-nav-panel">
                    <button
                      onClick={closeMobileMenu}
                      className="mobile-nav-close"
                      aria-label="Close menu"
                    >
                      ×
                    </button>

                    <div className="mobile-nav-logo">
                      <img src={logo} alt="3D Spot" />
                    </div>

                    <label
                      htmlFor="my-drawer-4"
                      onClick={closeMobileMenu}
                      className="mobile-nav-link"
                    >
                      Track
                    </label>

                    <Link
                      to="/subscription"
                      onClick={closeMobileMenu}
                      className="mobile-nav-link"
                    >
                      Subscription
                    </Link>

                    <Link
                      to="/gallery"
                      onClick={closeMobileMenu}
                      className="mobile-nav-link"
                    >
                      Gallery
                    </Link>

                    <Link
                      to="/blog"
                      onClick={closeMobileMenu}
                      className="mobile-nav-link"
                    >
                      Blog
                    </Link>

                    <Link
                      to="/about-us"
                      onClick={closeMobileMenu}
                      className="mobile-nav-link"
                    >
                      About Us
                    </Link>

                    <button
                      onClick={() => {
                        closeMobileMenu();
                        navigate("/guest-quote");
                      }}
                      className="mobile-nav-quote"
                    >
                      Get Free Quote
                    </button>

                    <button
                      onClick={() => {
                        closeMobileMenu();
                        navigate("/dashboard/create");
                      }}
                      className="mobile-nav-create"
                    >
                      Create Order
                    </button>

                    <button
                      onClick={() => {
                        closeMobileMenu();
                        navigate("/login");
                      }}
                      className="mobile-nav-login"
                    >
                      Login
                    </button>

                    <p className="mobile-nav-note">
                      Creating your project is quick, easy and completely free.
                    </p>
                  </div>
                </div>
              )} */}
              <Navbar />
              <section className="hero top-section-hero">
                <div className="hero-body">
                  <div className="flex max-w-screen flex-col lg:flex-row lg:items-center lg:justify-between gap-8 lg:gap-12">
                    <div className="basis-1/2 text-left">
                      <div className="mt-12">
                        <h1 className="title leading-tight mb-4">
                          Turn Any Photo
                          <br />
                          Into a Print-Ready
                          <br />
                          STL File.
                        </h1>

                        <p className="subtitle hero-subtitle text-center lg:text-left">
                          We transform your photo into a refined,
                          <br className="hidden lg:block" />
                          print-ready stl file with artist-crafted detail,
                          <br className="hidden lg:block" />
                          clean structure, and professional-quality results.
                        </p>

                        <div className="hero-cta-buttons">
                          {!isLoggedIn && (
                            <button
                              onClick={() => navigate("/guest-quote")}
                              className="primary-button hero-quote-button"
                            >
                              Get Free Quote
                            </button>
                          )}

                          <button
                            onClick={() => navigate("/dashboard/create")}
                            className="secondary-button hero-create-button"
                          >
                            Create Order
                          </button>
                        </div>

                        <div className="mt-6 hidden lg:flex w-[80px]">
                          <Lottie
                            height={150}
                            width={150}
                            options={{
                              ...defaultOptions,
                              animationData: animation2,
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="basis-1/2">
                      <Lottie options={defaultOptions} />
                    </div>
                  </div>

                  <div className="mt-6 sm:hidden w-[100px]">
                    <Lottie
                      height={100}
                      width={100}
                      options={{ ...defaultOptions, animationData: animation2 }}
                    />
                  </div>
                </div>
              </section>

              <h2 className="hidden">Custom 3D Modelling Services</h2>
              <h2 className="hidden">Convert Image to STL or 3D Model</h2>

              <Service />
              <Create />
              <Gallery id="gallery" />
              <Family />

              <section className="flex justify-center">
                <div
                  className="hero-body w-full flex justify-center items-center"
                  style={{ paddingTop: "0px" }}
                >
                  <div className="lets-do-it-box w-full">
                    <div className="flex lets-do-it-column justify-between items-center">
                      <div className="lg:text-left sm:text-center">
                        <p className="family-title mb-2">Lets Do it...</p>

                        <div className="family-subtitle mb-3 lg:flex lg:items-center gap-2">
                          <strong className="text-[20px]">
                            Design and scuplt
                          </strong>
                          <span className="text-[20px]">
                            3D Printable File.
                          </span>
                        </div>
                      </div>

                      <div>
                        <div className="create-buttons">
                          <button
                            onClick={() => navigate("/signup")}
                            className="secondary-button lg:w-80 w-auto"
                          >
                            Sign up and Start Building
                          </button>

                          <p className="project-subtitle ml-3 mr-3">or</p>

                          <button
                            onClick={() =>
                              openTalkToExperts(
                                "https://api.whatsapp.com/send?phone=918877680694&text=Hello,%20I%20want%20a%203D%20Model%20to%20be%20made"
                              )
                            }
                            className="primary-button lg:w-80 w-auto"
                          >
                            Talk to our Experts
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="hero">
                <Faq />
              </div>

              <Review id="review" />
            </div>

            <div className="drawer-side max-w-screen h-full">
              <label htmlFor="my-drawer-4" className="drawer-overlay"></label>

              <ul className="fixed top-0 right-0 flex-1 p-10 overflow-y-auto w-full max-w-md max-w-screen bg-[#06011A] text-left min-h-screen">
                <div className="flex justify-between items-center">
                  <div className="text-white font-semibold text-2xl pb-6">
                    Track Order
                  </div>

                  <label htmlFor="my-drawer-4" className="text-xl text-white">
                    <MdClose />
                  </label>
                </div>

                <div className="text-white font-medium text-lg pb-6">
                  Order Id
                </div>

                <input
                  onChange={(e) => setOid(e.target.value)}
                  type="text"
                  placeholder="Order Id eg. 897745623.."
                  className="input text-white border border-[#363636] w-full max-w-xs bg-[#1B1C2D] mb-6"
                />

                <button
                  type="submit"
                  className="secondary-button w-40 mt-6 mb-12"
                  onClick={handleTrack}
                >
                  Track
                </button>

                <div className="text-white font-medium text-lg">
                  {order?.title}
                </div>

                <ul className="steps steps-vertical">
                  {TrackingIndex.map((item, index) => (
                    <li
                      key={item.step}
                      className={`step ${index <= activeStep ? "step-accent text-white" : ""
                        }`}
                    >
                      {item.title}
                    </li>
                  ))}
                </ul>
              </ul>
            </div>
          </div>
        </div>

        <FloatingWhatsApp
          phoneNumber="19177643908"
          accountName="3D Spot"
          allowEsc
          allowClickAway
          avatar={logo}
          notificationSound={false}
        />

        <Footer />
      </section>
    </>
  );
};

export default Homepage;
